import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const SettingsHeader = () => {
  const navigate = useNavigate();
  
  return (
    <>
      <button
        onClick={() => navigate('/sanctuary')}
        className="flex items-center space-x-2 mb-6 text-stone-500 hover:text-stone-700 transition-colors"
        data-testid="back-to-sanctuary"
      >
        <ArrowLeft className="w-5 h-5" />
        <span>Back to Sanctuary</span>
      </button>
      
      <h1
        className="text-4xl font-medium text-stone-800 mb-2"
        style={{ fontFamily: 'Playfair Display, serif' }}
      >
        Settings
      </h1>
      <p className="text-stone-500 mb-8">
        Manage your account, preferences, and data
      </p>
    </>
  );
};
